import NextStep from 'modules/dashboard/components/NextStep/NextStep';

export default NextStep;
